import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptySetIconSolid = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "a",
	xmlns: "http://www.w3.org/2000/svg",
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M58.9,6.41l-7.9,7.9c3.28,4.38,5.25,9.81,5.25,15.69,0,14.47-11.78,26.25-26.25,26.25-5.88,0-11.31-1.97-15.7-5.25l-7.9,7.9c-.73,.73-1.69,1.1-2.65,1.1s-1.92-.36-2.65-1.1c-1.46-1.46-1.46-3.84,0-5.3l7.9-7.9c-3.28-4.38-5.25-9.8-5.25-15.69C3.75,15.53,15.53,3.75,30,3.75c5.88,0,11.31,1.97,15.69,5.25l7.9-7.9c1.46-1.46,3.84-1.46,5.3,0,1.46,1.47,1.46,3.84,0,5.31ZM14.38,40.32L40.32,14.37c-2.96-1.97-6.51-3.12-10.32-3.12-10.34,0-18.75,8.41-18.75,18.75,0,3.82,1.16,7.36,3.13,10.32Zm31.24-20.64l-25.95,25.95c2.96,1.96,6.51,3.12,10.32,3.12,10.34,0,18.75-8.41,18.75-18.75,0-3.82-1.16-7.36-3.13-10.32Z" })]
});
const ForwardRef = forwardRef(SvgEmptySetIconSolid);
export default ForwardRef;
